import {RunStates} from '../store/runStates'
import _ from 'lodash'

export default {
  name: 'downloadFunctionMixins',
  data () {
    return {
      influenceCategories: ['Well-represented', 'Neutral', 'Under-represented']
    }
  },
  computed: {
    strongestTTestOfClasses: function () {
      let strongest = 0.0
      // var t0 = performance.now()
      Object.keys(this.latestFeatures).forEach(featureSetKey => {
        this.latestFeatures[featureSetKey].forEach(feature => {
          if (Math.abs(feature.bestTtest) > strongest) { strongest = Math.abs(feature.bestTtest) }
        })
      })
      // var t1 = performance.now()
      // console.log('strongestTTest(): ' + (t1 - t0) + ' milliseconds')
      return strongest
    }
  },
  methods: {
    formatOccurrences (occurrences) {
      return _.sum(Object.values(occurrences))
    },
    getResultName (result) {
      // FIXME: hack to address the single chunk case, in which the server will return the first key for the chunk
      // instead of all the keys
      // if (this.dropDownUserSelection === 'Entire Text (Don’t divide)')
      if (this.testSetResults.length === 1) { // this works in textClassificationTab.vue AND experiment.vue
        return this.testText.displayName
      }
      return result.name.split('/').slice(4, 6).join('/')
    },
    getFeatureTypeFromNames () {
      const featureTypeMap = new Map()
      for (const featureType in this.$store.state.features) {
        for (const feature of this.$store.state.features[featureType]) {
          featureTypeMap.set(feature.featureName, featureType)
        }
      }
      return featureTypeMap
    },
    updateTestTextResults () {
      if (this.classifyState !== RunStates.COMPLETE || this.extractFeaturesState !== RunStates.COMPLETE) { return }
      const featureTypeMap = this.getFeatureTypeFromNames()
      // console.log('featureTypeMap:')
      // console.log(featureTypeMap)
      const newSetResults = this.$store.state.testTextResults.map(result => {
        const extendedResult = Object.assign({
          show: false,
          loading: false,
          timedOut: false,
          failed: false,
          arrangedReviewText: []
        }, result)
        extendedResult.featureList = []
        result.orderedFeatureInfluences.forEach(featureObj => {
          var oneFeature = {
            name: featureObj[0],
            type: featureTypeMap.get(featureObj[0]),
            freqInDoc: featureObj[1].fractionInText,
            influence: featureObj[1].normalizedInfluence,
            averageForEachClass: {
              'Others': featureObj[1].fractionInTheOtherClasses
            }
          }
          // console.log('oneFeature.type:')
          // console.log(oneFeature.type)
          this.$store.state.features[oneFeature.type].forEach(sameType => {
            if (sameType.featureName === oneFeature.name) {
              oneFeature['tTest'] = sameType.bestTtest
              oneFeature['orderByClass'] = +(sameType.bestClass.substr(5))
              oneFeature['classifiedAs'] = this.classes[+(sameType.bestClass.substr(5))].displayName
              oneFeature['bestClassOccurrences'] = sameType.counts[sameType.bestClass]
              oneFeature['otherClassOccurrences'] = _.sum(Object.values(sameType.counts)) - oneFeature.bestClassOccurrences
            }
          })
          oneFeature.averageForEachClass[oneFeature['classifiedAs']] = featureObj[1].fractionInTextClass
          extendedResult.featureList.push(oneFeature)
        })
        extendedResult.classID = +(result.predictedClass.substr(5))
        extendedResult.classifiedAs = this.classes[extendedResult.classID].displayName
        extendedResult.name = result.textKey
        return extendedResult
      })
      for (var i = 0; i < newSetResults.length; i++) {
        newSetResults[i].index = i + 1
      }
      this.testSetResults = newSetResults
    },
    categorizedFeatureSetsArray: function (featureSet) {
      var catArray
      /* if ((this.primaryKey === 'Class') && (this.secondaryKey === 'Significance in Test Text')) { */
      catArray = Object.entries(_.groupBy(featureSet, this.categorizeFeatureSetName))
      catArray.sort((a, b) => {
        return this.influenceCategories.indexOf(a[0]) - this.influenceCategories.indexOf(b[0])
      })
      /* } else {
        catArray = [['all', featureSet]]
      } (COMMENTED BECAUSE DECIDED TO ONLY SECTION BY CLASS) */
      var sortKeys
      /* if (this.primaryKey === 'Class') {
        sortKeys = [this.secondaryKey]
      } else */ sortKeys = [this.secondaryKey, this.primaryKey]
      catArray.forEach(iCat => {
        iCat[1].sort((a, b) => {
          return this.featureSortFunction(this.chunkResults.featureList[a], this.chunkResults.featureList[b], sortKeys)
        })
      })
      // console.log('catArray:')
      // console.log(catArray)
      return catArray
    },
    categorizeFeatureSet: function (featureArrayIndex) {
      if (this.chunkResults.featureList[featureArrayIndex].influence > 0) { return 0 }
      if (this.chunkResults.featureList[featureArrayIndex].influence === 0.0) { return 1 }
      if (this.chunkResults.featureList[featureArrayIndex].influence < 0) { return 2 }
    },
    categorizeFeatureSetName: function (featureArrayIndex) {
      return this.influenceCategories[this.categorizeFeatureSet(featureArrayIndex)]
    },
    featureSortFunction: function (feature1, feature2, originalSortKeys) {
      var func = 0
      var key
      var sortKeys = []
      originalSortKeys.forEach(originalKey => {
        sortKeys.push(originalKey)
      })
      while ((sortKeys.length > 0) && (func === 0)) {
        key = sortKeys.pop()
        if (key.name === 'Feature') {
          if (this.prettyPrint(feature1.name).toLowerCase() === this.prettyPrint(feature2.name).toLowerCase()) {
            func = 0
          } else if (this.prettyPrint(feature2.name).toLowerCase() < this.prettyPrint(feature1.name).toLowerCase()) {
            func = 1
          } else func = -1
        }
        if (key.name === 'Class') {
          func = feature1.orderByClass - feature2.orderByClass
        }
        if (key.name === 'FreqInDoc') {
          func = feature2.freqInDoc - feature1.freqInDoc
        }
        if (key.name === 'Frequency') {
          func = feature2.averageForEachClass['Others'] - feature1.averageForEachClass['Others']
        }
        if (key.name === 'Importance') {
          func = Math.abs(feature2.influence) - Math.abs(feature1.influence)
        }
        if (key.name === 'Significance') {
          func = Math.abs(feature2.tTest) - Math.abs(feature1.tTest)
        }
        if (!(key.defaultOrder)) {
          func = -1 * func
        }
      }
      return func
    },
    getClassName (classIndex) {
      if (this.classes[classIndex]) {
        return this.classes[classIndex].displayName
      } else {
        return 'Class ' + classIndex
      }
    },
    frequencyMiniTable (feature) {
      let fTable = []
      Object.keys(feature.averageForEachClass).forEach(className => {
        if (className !== 'Others') {
          fTable.push({
            text: className + ' ' + (feature.averageForEachClass[className] * 100).toFixed(2) + '%',
            title: feature.bestClassOccurrences + ' occurrences'
          })
        }
      })
      if ('Others' in feature.averageForEachClass) {
        fTable.push({
          text: 'Others ' + (feature.averageForEachClass['Others'] * 100).toFixed(2) + '%',
          title: feature.otherClassOccurrences + ' occurrences'
        })
      }
      // console.log('fTable:')
      // console.log(fTable)
      return fTable
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/downloadFunctionMixins.js